<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        <span class="decoration">Employee</span>
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        <span class="decoration">Learning</span>
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        Manage Jobs
      </h6>

      <div class="container-fluid">
        <div class="navbar background_color filter-bar">
          <div class="d-flex flex-wrap align-items-center toolbar-left">
            <b-input-group size="sm" class="search-box">
              <b-form-input v-model="search" type="search" placeholder="Search" class="bdr-rad"></b-form-input>
            </b-input-group>
            <span class="custom-breadcrumb"><b>Showing {{ filteredAssignments.length }} items.</b></span>
          </div>
          <div class="toolbar-actions">
           
            <router-link to="/job/create" class="btn btn-sm btn-outline-primary bdr-rad router-button font-size_def">Create</router-link>
          </div>
        </div>

        <div class="card bdr-rad2 shadow p-2">
          <div class="card-body mb-5">
            <div v-if="errorMessage" class="alert alert-danger py-2">{{ errorMessage }}</div>
            <div v-if="isLoading" class="text-center"><div class="spinner-border text-primary"></div></div>
            <div v-else class="table-responsive">
              <b-table small hover show-empty class="job-table" :items="filteredAssignments" :fields="fields" head-variant="dark">
                <template #cell(number)="row">{{ row.index + 1 }}</template>
                <template #cell(job_description)="row"><span class="description-cell">{{ row.item.job_description || '-' }}</span></template>
                <template #cell(files)="row">
                  <div v-if="row.item.files.length" class="stacked-values">
                    <a v-for="file in row.item.files" :key="file" :href="fileUrl(file)" target="_blank">{{ fileName(file) }}</a>
                  </div>
                  <span v-else>-</span>
                </template>
                <template #cell(links)="row">
                  <div v-if="row.item.links.length" class="stacked-values">
                    <a v-for="link in row.item.links" :key="link" :href="link" target="_blank">{{ link }}</a>
                  </div>
                  <span v-else>-</span>
                </template>
                <template #cell(status)="row">{{ row.item.status === 1 ? 'Active' : 'Inactive' }}</template>
                <template #cell(actions)="row"><router-link :to="'/job/update?id=' + row.item.id" class="btn btn-sm btn-outline-primary bdr-rad font-size_def">Update</router-link></template>
                <template #empty><div class="text-center">No jobs found.</div></template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from 'axios';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';

export default {
  components: { TopNavbar, ContentFooter },
  data() {
    return {
      token: authService.isLoggedIn(),
      search: '',
      assignments: [],
      isLoading: true,
      errorMessage: '',
      fields: [
        { key: 'number', label: '#' },
        { key: 'job_title', label: 'Job Title' },
        { key: 'job_description', label: 'Job Description' },
        { key: 'employee', label: 'People' },
        { key: 'files', label: 'File Upload' },
        { key: 'links', label: 'Links' },
        { key: 'created_date', label: 'Created Date' },
        { key: 'status', label: 'Status' },
        { key: 'actions', label: 'Actions' },
      ],
    };
  },
  computed: {
    filteredAssignments() {
      const value = this.search.trim().toLowerCase();
      if (!value) return this.assignments;
      return this.assignments.filter((item) => [item.job_title, item.job_description, item.employee, item.created_date].join(' ').toLowerCase().includes(value));
    },
  },
  mounted() { this.loadAssignments(); },
  methods: {
    async loadAssignments() {
      try {
        const { data } = await axios.get('/ticourses/job-assignments', { headers: { Authorization: 'Bearer ' + this.token } });
        this.assignments = (data.data || []).map((item) => ({ ...item, files: item.files || [], links: item.links || [] }));
      } catch (error) { this.errorMessage = 'Unable to load jobs.'; } finally { this.isLoading = false; }
    },
    fileUrl(file) {
      if (!file) return '';
      if (/^https?:\/\//i.test(file)) return file;
      return window.location.origin + '/' + String(file).replace(/^\/+/, '');
    },
    fileName(file) { return file.split('/').pop(); },
  },
};
</script>

<style scoped>
.background_color { background: #eaf6ff; min-height: calc(100vh - 60px); }
.bdr-rad { border-radius: 12px; }
.bdr-rad2 { border-radius: 15px; }
.decoration { color: #fff !important; text-decoration: none; }
.font1 { font-size: 13px !important; }
.manage-boder { background: #087df5; color: #fff; padding: 10px 15px !important; margin: 0 !important; line-height: normal; }
.filter-bar { border: 0; padding: 2px 0 !important; margin: 0 !important; min-height: 40px; display: flex !important; flex-wrap: nowrap !important; justify-content: space-between; align-items: center; gap: 8px; }
.toolbar-left { flex: 1 1 auto; gap: 8px; }
.search-box { flex: 0 0 205px; max-width: 205px; }
.custom-breadcrumb { white-space: nowrap; margin-top: 11px; }
.toolbar-actions { display: flex; gap: 8px; }
.job-table { font-size: small; }
.stacked-values { display: flex; flex-direction: column; gap: 3px; }
.stacked-values a { display: list-item; list-style: disc inside; word-break: break-word; }
.description-cell { white-space: pre-line; }
@media (max-width: 768px) { .filter-bar { overflow-x: auto; } .toolbar-actions { flex-wrap: nowrap; } }
</style>
